"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconBaseName = getIconBaseName;
function getIconBaseName(name) {
  return name.replace(/(Small|ExtraSmall|Medium|Large)$/, '');
}